
// =========================
// FILTERS
// =========================
import './app/filters/isRadioOrderProperty.filter';
import './app/filters/isShowPrice.filter';
import './app/filters/isShowAddToBasket.filter';
import './app/filters/wishListItemVariationProperties.filter';

$(function () {
  $('body').on('click', '.widget-list.collapsible .widget-inner .h4, .widget-link-list.collapsible .widget-inner .h4', function () {
    const list = $(this).parent().find('ul.list-unstyled');
    if (list.is(':visible')) {
      $(this).parent().addClass('collapsed');
    } else {
      $(this).parent().removeClass('collapsed');
    }
    list.slideToggle('fast');
  });

  if (!App.isShopBuilder) {
    if (window.matchMedia('(max-width: 768px)').matches) {
      $('.widget-link-list.collapsible .widget-inner .h4').click();
      $('.widget-list.collapsible .widget-inner .h4').click();
    }
  }

  $('body').on('click', '[data-anchor]', function () {
    const headerHeight = window.matchMedia('(max-width: 991.98px)').matches ? ($('#page-header.sticky-top').height() || 0) : 0;
    const anchorId = $(this).data('anchor');
    const destinationElement = $('body').find("[data-anchor-destination='" + anchorId + "']");
    if (destinationElement.length) {
      $('html, body').animate({
        scrollTop: destinationElement.offset().top - headerHeight
      }, 800);
    }
    return false;
  });

  $('body').on('click', '.goto-contact', function () {
    const headerHeight = window.matchMedia('(max-width: 991.98px)').matches ? ($('#page-header.sticky-top').height() || 0) : 0;
    const lastTab = $('.widget-tab .nav-tabs .nav-item:last-of-type .nav-link');
    if (lastTab.length) {
      lastTab[0].click();
      $('html, body').animate({
        scrollTop: lastTab.offset().top - headerHeight
      }, 500);
    }
    return false;
  });

  if ($('body').hasClass('page-singleitem')) {
    // custom property selection in single view
    const opInterval = setInterval(function () {
      const sliderInner = $('.order-property-slider-inner');
      if (sliderInner.length > 0) {
        $('.radio-dropdown').find('input').change(function () {
          const dropdown = $(this).closest('.dropdown');
          const radioname = $(this).attr('name');
          const checked = 'input[name=' + radioname + ']:checked';

          // update the text
          const checkedtext = $(checked).next('label').text();
          dropdown.find('button').text(checkedtext);
        });

        // not apply dropdown for input checkbox
        /*const ul = $('input[type=checkbox]').closest('ul');
        const dropdownDiv = ul.closest('div');
        ul.removeClass('dropdown-menu dropdown-menu-select radio-dropdown');
        dropdownDiv.find('button').remove();*/

        // set value default
        const inputRadioFirst = $('div.dropdown > ul > li:first-child').find('input[type=radio]');
        inputRadioFirst.trigger('click');

        clearInterval(opInterval);
      }
    }, 1000);

    /*setInterval(function () {
      // not apply dropdown for input checkbox
      const ul = $('.dropdown-menu-select input[type=checkbox]').closest('ul');
      const dropdownDiv = ul.closest('div');
      ul.removeClass('dropdown-menu dropdown-menu-select radio-dropdown');
      dropdownDiv.find('button').remove();
    }, 500);*/
  }

  const contactVal = $('#contact_wish').val();
  if (contactVal) {
    if (contactVal.indexOf('Ich möchte nach dem Kauf eines elektronischen Geräts ein vergleichbares altes Elektrogerät kostenfrei zur Entsorgung abholen lassen.') > 0) {
      $('#bns-accept').attr('checked', true);
    }
  }
  $('#bns-accept').change(function () {
    if (this.checked) {
      $('#contact_wish').val(contactVal + '\nIch möchte nach dem Kauf eines elektronischen Geräts ein vergleichbares altes Elektrogerät kostenfrei zur Entsorgung abholen lassen.')[0].dispatchEvent(new Event('change'));
    } else {
      $('#contact_wish').val(contactVal.replace('\nIch möchte nach dem Kauf eines elektronischen Geräts ein vergleichbares altes Elektrogerät kostenfrei zur Entsorgung abholen lassen.', ''))[0].dispatchEvent(new Event('change'));
    }
  });
});
